export default __webpack_public_path__ + "static/media/42.68643a3e.jpg";